import Image from '@/components/image/NextImage';
import { formatResizedUrl } from '@/utils/app/formatResizedUrl';

import { Avatar, Container, Descriptor, Line, TextColumn, Title } from './styles';
import { ContentCardMetadataProps } from './types';
import { getDailyLines, getPlainLines } from './utils';

const AVATAR_IMAGE_SIZE = 88;

const ContentCardMetadata = ({
	variant,
	title,
	titleElement = 'h3',
	contentType,
	narratorName,
	subtitle,
	description,
	promotionalText,
	avatarUrl,
}: ContentCardMetadataProps) => {
	if (variant === 'daily') {
		const { descriptor, dateLine } = getDailyLines({
			contentType,
			narratorName,
			subtitle,
			description,
			promotionalText,
		});

		return (
			<Container $variant="daily">
				{avatarUrl && (
					<Avatar data-testid="metadata-avatar">
						<Image
							fill
							style={{ objectFit: 'cover' }}
							src={formatResizedUrl(avatarUrl, AVATAR_IMAGE_SIZE, AVATAR_IMAGE_SIZE)}
							alt=""
							sizes="44px"
						/>
					</Avatar>
				)}
				<TextColumn $variant="daily">
					{title && <Title el={titleElement}>{title}</Title>}
					{descriptor && (
						<Descriptor $lines={2} $topGap={4}>
							{descriptor}
						</Descriptor>
					)}
					{dateLine && <Line $topGap={6}>{dateLine}</Line>}
				</TextColumn>
			</Container>
		);
	}

	const { secondary, episode } = getPlainLines({ title, contentType, narratorName, subtitle });

	return (
		<Container $variant="plain">
			<TextColumn $variant="plain">
				{title && <Title el={titleElement}>{title}</Title>}
				{secondary && (
					<Descriptor $lines={1} $topGap={0}>
						{secondary}
					</Descriptor>
				)}
				{episode && <Line $topGap={0}>{episode}</Line>}
			</TextColumn>
		</Container>
	);
};

export default ContentCardMetadata;
